<template>
  <div>
    <div v-if="!isUnlock" style="position: absolute; left: 0px;right: 0px;bottom: 0;top: 0;">
      <div
        style="color: black; z-index: 1;  top: 0; left: 0; right: 0; bottom: 0 "
        :style="{
          position: 'absolute',
          'background-color': '#ecececbd'
        }"
      >
        <v-layout fill-height column justify-center>
          <div
            class="text-xs-center mt-4"
            style="margin-bottom: 25px;"
            :style="{ 'margin-top': 0 + 'px' }"
          >
            <h2 style="text-shadow: 1px 1px 20px #9e9e9e;" class="display-1">
              {{ $t('Its time to upgrade.') }}
            </h2>
            <template v-if="selectedBot.pagetype != 'enterprise'">
              <p style="text-shadow: rgb(80, 80, 80) 1px 1px 20px;">
                {{ $t('Upgrade Your Plan to use livechat feature , only 999 THB/month') }}
              </p>

              <v-btn
                depressed
                style="margin-bottom:1.5em"
                target="_blank"
                href="https://m.me/361231620965547?ref=livechat"
                small
                color="primary"
                >{{ $t('GET/CONTINUE PREMIUM') }}</v-btn
              >
            </template>
          </div>
        </v-layout>
      </div>
    </div>
    <livechat-search v-model="showSearch"></livechat-search>
    <div id="livechat" v-if="$store.getters.getPackage == 'premium'">
      <div v-show="view == 'users'">
        <div id="chattype">
          <template v-if="searchlist.length == 0">
            <livechat-tab
              :isMobile="true"
              :newchatnotify="newchatnotify"
              @onsearch="showSearch = true"
              @clearAllUnread="clearAllUnread"
            ></livechat-tab>
          </template>
          <template v-else>
            <livechat-search-box @onsearch="showSearch = true"></livechat-search-box>
            <v-divider></v-divider>
          </template>
        </div>

        <div
          :style="{
            'margin-top': !searchlist ? '84px' : '0'
          }"
        >
          <users
            :newchatnotify="newchatnotify"
            v-model="selectedUser"
            :app="$store.state.livechat.app"
            :line_tab="$store.state.livechat.line_tab"
            :usersearching="usersearching"
            :filter="filter"
            :type="'admin'"
            v-if="$store.state.livechat.type == 'admin'"
            @onClickUser="onClickUser"
            :isMobile="true"
            @onSearch="onSearch"
            @livechatnotiunread="createUnreadInterval"
          ></users>
          <users
            :newchatnotify="newchatnotify"
            v-model="selectedUser"
            :usersearching="usersearching"
            :app="$store.state.livechat.app"
            :line_tab="$store.state.livechat.line_tab"
            :filter="filter"
            :type="'bot'"
            v-if="$store.state.livechat.type == 'bot'"
            @onClickUser="onClickUser"
            :isMobile="true"
            @onSearch="onSearch"
            @livechatnotiunread="createUnreadInterval"
          ></users>
        </div>
      </div>
      <div v-if="view == 'chatbox'">
        <template v-if="selectedUser">
          <chatbox
            v-model="selectedUser"
            @endSession="onEndSession"
            @onClose="onCloseChatbox"
            @onShowTool="onShowTool"
            :isMobile="true"
            :key="selectedUser.userid || selectedUser.group_id"
            :app="selectedUser.app"
          ></chatbox>

          <v-navigation-drawer v-model="showTool" right fixed temporary>
            <v-layout>
              <v-flex>
                <v-btn fab small flat class="extra-small" @click="showTool = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
              <v-flex class="text-xs-right">
                <v-btn
                  small
                  outline
                  @click="onEndSession"
                  v-if="selectedUser.context == 'contactadmin'"
                  >{{ $t('Switch to bot') }}</v-btn
                >
                <v-btn
                  small
                  outline
                  @click="onOpenSession"
                  v-else-if="selectedUser.context != 'contactadmin'"
                  >{{ $t('Switch to admin') }}</v-btn
                >
              </v-flex>
            </v-layout>
            <template v-if="selectedUser">
              <livechat-chattool :selectedUser="selectedUser"></livechat-chattool>
            </template>
          </v-navigation-drawer>
        </template>
      </div>
    </div>
    <div v-else style="position: relative">
      <v-premium-plan-popup
        backgroundColor="white"
        v-if="$store.getters.getPackage != 'premium'"
        style="border-radius: 10px; min-height: 100vh; height: 100%"
      ></v-premium-plan-popup>
    </div>
  </div>
</template>

<script>
import Livechat from './Livechat.js'
import LivechatCustomers from './livechat-customers'
export default {
  mixins: [Livechat],
  components: {
    LivechatCustomers
  },
  data() {
    return {
      showTool: false,
      view: 'users',
      chattooltype: 'customer'
    }
  },
  methods: {
    onShowTool: function() {
      this.showTool = !this.showTool
    },
    onCloseChatbox: function() {
      this.$set(this.$store.state.livechat, 'currentUser', null)
      this.view = 'users'
    },
    onClickUser: function() {
      this.view = 'chatbox'
    },
    // onEndSession: async function() {
    //   console.log('onEndSession')
    //   this.type = 'bot'
    //   await this.endSession()
    //   this.$set(this.$store.state.livechat, 'currentUser', null)
    //   this.$store.dispatch('updateLivechatUser', null)
    //   this.$store.dispatch('forceLoadLastestUsers')
    //   this.updateRoute()
    //   this.showTool = false
    //   // this.view = 'users'
    // },
    // onOpenSession: async function() {
    //   console.log('onOpenSession')
    //   await this.openSession()
    //   this.type = 'admin'
    //   this.$store.commit('SET_LIVECHAT_TYPE', 'admin')
    //   var user = this.$store.state.livechat.currentUser
    //   user.type = this.type

    //   this.$store.dispatch('updateLivechatUser', user)
    //   this.$store.dispatch('forceLoadLastestUsers')
    //   this.updateRoute()
    //   this.showTool = false
    //   // this.view = 'users'
    // },
    afterEndSession() {
      const vm = this
      vm.showTool = false
      vm.view = 'users'
    },
    afterOpenSession() {
      const vm = this
      vm.showTool = false
      vm.view = 'users'
      vm.$store.commit('SET_LIVECHAT_TYPE', 'admin')
    },

    onResizeToolList: function() {
      var vm = this
      vm.$nextTick(function() {
        var toolListHeight = 0
        if (document.getElementById('chattool')) {
          toolListHeight = document.getElementById('chattool').clientHeight
        }
        vm.toolListHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - toolListHeight
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatMobile.vue